/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Col, Container, Row, Card, CardBody, Table, Button} from 'reactstrap';
import {Link} from "react-router-dom";
import { Link as LinkR} from 'react-scroll'

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeart} from '@fortawesome/free-solid-svg-icons';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';
import ModalVideo from './modals/modal-video';
import Settings from '../custom-classes/settings';
import LiveChat from 'react-livechat';

/**
 * The component (window) landing (index page)
 */
class LandingPage extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            isHovered: false,
            videoModalOpenend: false,
            showOffer: true,
            chatLiveChatLicense: Settings.CHAT_LIVE_CHAT_LICENSE
        };
        this.props.addTranslation(global);
        this.handleHover = this.handleHover.bind(this);
        this.openModal = this.openModal.bind(this);
        this.hideOffer = this.hideOffer.bind(this);
    }

    openModal(){
        this.setState({
            videoModalOpenend : !this.state.videoModalOpenend
        })
    }

    handleHover() {
        this.setState({
            isHovered: !this.state.isHovered
        });
    }

    /**
     * To hide the offer
     */
    hideOffer(){
        this.setState({
            showOffer: false
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render() {
        const btnClass = this.state.isHovered ? "pulse animated" : "";
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="landing-main">
                    <img src={require('../img/alexus-main.png')} alt="Alexus"
                         className="landing-alexus animated delay-2s fadeIn"/>
                    <img src={require('../img/menta-main.png')} alt="Menta"
                         className="landing-menta animated delay-1s fadeIn"/>
                    <img src={require('../img/gnocsis-main.png')} alt="Gnocsis"
                         className="landing-gnocsis animated  slideInLeft"/>
                    <img src={require('../img/logo-main.png')} alt="Company logo"
                         onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}
                         className={ btnClass + " landing-main-logo"}/>
                    <div className="div-nerd">
                        <img src={require('../img/col-character.png')} alt="Nerd"
                         onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}
                         className={ btnClass + " landing-nerd"}/>
                        <LinkR  activeClass="active" to="section1" spy={true} smooth={true} duration={500}
                               className="btn font-now-bold btn-nerd animated pulse infinite" >
                            <Translate id="landing-page.what-is-genial-web"/>
                        </LinkR>
                    </div>
                    {this.state.showOffer?
                        <div className="special-offer btn btn-warning centered-text">
                                <h2>
                                    <Translate id="landing-page.special-offer" options={{renderInnerHtml: true}}/>
                                    <div className="close-button-simple" onClick={this.hideOffer}>x</div>
                                </h2>
                                <h2 className="font-now-bold">
                                    <Translate id="landing-page.percent-off" options={{renderInnerHtml: true}}/></h2>
                                <p><Translate id="landing-page.percent-off-explain" options={{renderInnerHtml: true}}/></p>
                                <Link className="btn btn-info" to="/select-plan">
                                        <Translate id="landing-page.learn-more" options={{renderInnerHtml: true}}/>
                                </Link>
                        </div> : null
                    }
                    {!this.state.navbarMobile ?
                        <div className="div-watch-trailer centered-text animated fadeIn delay-3s font-size-3vh">
                            <p className="font-now-bold text-glow">
                                <Translate id="landing-page.watch-trailer"/>
                            </p>
                            <img className="btn-play-trailer " src={require('../img/play-button.png')} alt="play-trailer" onClick={this.openModal} />

                        </div>
                       : null
                    }
                    <br/>
                    {
                        this.state.videoModalOpenend ?
                            <ModalVideo visible={this.state.videoModalOpenend} updateParent={this.openModal} /> : null
                    }
                </div>

                <div name="section1" className="container-white container-padding">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.main" options={{renderInnerHtml: true}}/>
                                </h1>
                            </Col>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card className="card-gray border-none">
                                    <CardBody>
                                        <Row>
                                            <Col lg={{size: 8}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                                <div className="font-size-3vh text-left">
                                                    <Translate id="landing-page.main-subtitle" options={{renderInnerHtml: true}}/>
                                                </div>
                                                <div className="blue-text font-size-3vh text-left">
                                                    <LinkR onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}
                                                           className={ btnClass +" btn btn-info white-text font-now-bold btn-bigger"} activeClass="active" to="section2" spy={true} smooth={true} duration={500}>
                                                        <Translate id="landing-page.what-we-include"/>
                                                    </LinkR>
                                                </div>
                                            </Col>
                                            <Col lg={{size: 4}} md={{size: 0}} sm={{size: 0}} xs={{size: 0}}>
                                                <img src={require('../img/main.png')} className="img-fluid" alt="Main promo"/>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg={{size:12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <Table responsive>
                                    <thead className="table-head-blue white-text">
                                    <tr>
                                        <th>
                                            <Translate id="landing-page.subject"/>
                                        </th>
                                        <th>K</th>
                                        <th>1</th>
                                        <th>2</th>
                                        <th>3</th>
                                        <th>4</th>
                                        <th>5</th>
                                        <th>6</th>
                                        <th>7</th>
                                        <th>8</th>
                                        <th>9</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th scope="row" className="table-td-main text-right">
                                            <Translate id="landing-page.spanish"/>
                                        </th>
                                        <td/>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" className="table-td-main text-right">
                                            <Translate id="landing-page.english"/>
                                        </th>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" className="table-td-main text-right">
                                            <Translate id="landing-page.science-en"/>
                                        </th>
                                        <td/>
                                        <td/>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td/>
                                        <td/>
                                        <td/>
                                        <td/>
                                        <td/>
                                        <td/>
                                    </tr>
                                    <tr>
                                        <th scope="row" className="table-td-main text-right">
                                            <Translate id="landing-page.math-en"/>
                                        </th>
                                        <td/>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td/>
                                        <td/>
                                        <td/>
                                        <td/>
                                        <td/>
                                        <td/>
                                    </tr>
                                    <tr>
                                        <th scope="row" className="table-td-main text-right">
                                            <Translate id="landing-page.math-sp"/>
                                        </th>
                                        <td/>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td/>
                                        <td/>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                        <td className="table-td-fill white-text">&bull;</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div name="section2" className="container-orange container-padding" >
                    <Container>
                        <Row className="text-center text-white margin-top-mandatory-25">
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.subjects"/>
                                </h1>
                                <hr/>
                                <h2><Translate id="landing-page.subjects-include"/></h2>
                            </Col>

                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Row>
                                    <Col lg={{size: 3}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                        <Card className="green-text">
                                            <CardBody>
                                                <img src={require('../img/icon-math.png')} className="img-fluid" alt="Main promo"/>

                                                <hr/>
                                                <h2 className="font-now-bold"><Translate id="landing-page.math"/></h2>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={{size: 3}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                        <Card className="blueish-text">
                                            <CardBody>
                                                <img src={require('../img/icon-spanish.png')} className="img-fluid" alt="Main promo"/>
                                                <hr/>
                                                <h2 className="font-now-bold"><Translate id="landing-page.spanish"/></h2>
                                            </CardBody>
                                        </Card>
                                    </Col>

                                    <Col lg={{size: 3}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                        <Card className="dark-coral-text">
                                            <CardBody>
                                                <img src={require('../img/icon-science.png')} className="img-fluid" alt="Main promo"/>
                                                <hr/>
                                                <h2 className="font-now-bold"><Translate id="landing-page.science"/></h2>
                                            </CardBody>
                                        </Card>
                                    </Col>

                                    <Col lg={{size: 3}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                        <Card className="violet-text">
                                            <CardBody>
                                                <img src={require('../img/icon-english.png')} className="img-fluid" alt="Main promo"/>
                                                <hr/>
                                                <h2 className="font-now-bold"><Translate id="landing-page.english"/></h2>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <hr/>
                                <LinkR onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}
                                       activeClass="active" to="section3" spy={true} smooth={true} duration={500}
                                       className={ btnClass +" btn btn-info white-text font-now-bold btn-bigger"}>
                                    <Translate id="landing-page.our-curriculum"/>
                                </LinkR>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-blue white-text container-padding" name="section3">
                    <Container>
                        <Row className="text-center margin-top-mandatory-50">
                            <Col lg={{size: 10, offset: 1}} md={{size: 10, offset: 1}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}}>
                                <img src={require('../img/curriculum.png')} className="img-fluid" alt="Main promo"/>
                            </Col>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.curriculum" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <h2><Translate id="landing-page.curriculum-1" options={{renderInnerHtml: true}}/></h2>
                                <h2><Translate id="landing-page.curriculum-3" options={{renderInnerHtml: true}}/>
                                    <FontAwesomeIcon className="fa-2x red-text" icon={faHeart}/>.</h2>
                                <LinkR onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}
                                        activeClass="active" to="section4" spy={true} smooth={true} duration={500}
                                       className={ btnClass +" btn btn-info white-text font-now-bold btn-bigger"}>
                                    <Translate id="landing-page.fun-activities"/>
                                </LinkR>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-white container-padding" name="section4">
                    <Container>
                        <Row className="text-center margin-top-mandatory-50">
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.activities" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <Row>
                                    <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                        <Row>
                                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                                <Card className="card-blue border-none">
                                                    <CardBody>
                                                         <h2 className="font-now-bold">
                                                             <Translate id="landing-page.travel-around" options={{renderInnerHtml: true}}/></h2>
                                                        <img src={require('../img/activity-map.png')}
                                                             className="img-fluid" alt="lessons"/>
                                                        <p className="font-size-2-5vh"><Translate id="landing-page.travel-around-subtitle" options={{renderInnerHtml: true}}/></p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                        <Row>
                                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                                <Card className="card-orange border-none">
                                                    <CardBody>
                                                        <h2 className="font-now-bold">
                                                            <Translate id="landing-page.lessons-activity" options={{renderInnerHtml: true}}/></h2>
                                                        <img src={require('../img/activity-lesson-inside.png')}
                                                             className="img-fluid" alt="lessons"/>
                                                        <p className="font-size-2-5vh"><Translate id="landing-page.lessons-activity-subtitle" options={{renderInnerHtml: true}}/></p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                        <Row>
                                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                                <Card className="card-green border-none">
                                                    <CardBody>
                                                        <h2 className="font-now-bold">
                                                            <Translate id="landing-page.create-avatar" options={{renderInnerHtml: true}}/></h2>
                                                        <img src={require('../img/activity-create-your-avatar.png')}
                                                             className="img-fluid" alt="lessons"/>
                                                        <p className="font-size-2-5vh"><Translate id="landing-page.create-avatar-subtitle" options={{renderInnerHtml: true}}/></p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                        <Row>
                                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                                <Card className="card-red border-none">
                                                    <CardBody>
                                                        <h2 className="font-now-bold">
                                                            <Translate id="landing-page.compete" options={{renderInnerHtml: true}}/></h2>
                                                        <img src={require('../img/activity-versus.png')}
                                                             className="img-fluid" alt="lessons"/>
                                                        <p className="font-size-2-5vh"><Translate id="landing-page.compete-subtitle" options={{renderInnerHtml: true}}/></p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                        <Row>
                                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                                <Card className="card-cyan border-none">
                                                    <CardBody>
                                                        <h2 className="font-now-bold">
                                                            <Translate id="landing-page.mini-games" options={{renderInnerHtml: true}}/></h2>
                                                        <img src={require('../img/activity-mini-games.png')}
                                                             className="img-fluid" alt="lessons"/>
                                                        <p className="font-size-2-5vh"><Translate id="landing-page.mini-games-subtitle" options={{renderInnerHtml: true}}/></p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                        <Row>
                                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                                <Card className="card-violet border-none">
                                                    <CardBody>
                                                        <h2 className="font-now-bold">
                                                            <Translate id="landing-page.fun-quizzes" options={{renderInnerHtml: true}}/></h2>
                                                        <img src={require('../img/activity-fun-quizzes.png')}
                                                             className="img-fluid" alt="lessons"/>
                                                        <p className="font-size-2-5vh"><Translate id="landing-page.fun-quizzes-subtitle" options={{renderInnerHtml: true}}/></p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>


                                <hr/>
                                <LinkR onMouseEnter={this.handleHover} onMouseLeave={this.handleHover} activeClass="active" to="section5" spy={true} smooth={true} duration={500}
                                       className={ btnClass +" btn btn-warning white-text font-now-bold btn-bigger"}>
                                    <Translate id="landing-page.and-for-parents"/>
                                </LinkR>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-white container-padding" name="section5">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.track-progress" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <img src={require('../img/activity-dashboard.png')} className="img-fluid"
                                     alt="Landing Math"/>
                                <h2>
                                    <Translate id="landing-page.track-progress-1" options={{renderInnerHtml: true}}/>
                                </h2>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-teal container-padding white-text"
                     style={{backgroundImage: "url(" +require('../img/testimonials.jpg')  + ")"}}>
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.testimonials" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <h2>
                                    <Translate id="landing-page.testimonial-1" options={{renderInnerHtml: true}}/>
                                </h2>
                                <br/>
                                <h2>
                                    <Translate id="landing-page.testimonial-2" options={{renderInnerHtml: true}}/>
                                </h2>
                                <br/>
                                <h2>
                                    <Translate id="landing-page.testimonial-3" options={{renderInnerHtml: true}}/>
                                </h2>
                            </Col>
                        </Row>
                    </Container>
                </div>


                <div className="container-white container-padding">
                    <Container>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                                <img src={require('../img/offer-gnocsis.png')} className="img-fluid animated pulse infinite"
                                     alt="Offer"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                                <Card className="card-red">
                                    <CardBody>
                                    <h1 className="font-now-bold centered-text">
                                        <Translate id="landing-page.free-trial" options={{renderInnerHtml: true}}/>
                                    </h1>
                                        <hr/>
                                        <h2 className="font-now-bold centered-text">
                                            <Translate id="landing-page.no-commitment" options={{renderInnerHtml: true}}/>
                                        </h2>
                                        <p><Translate id="landing-page.free-trial-explain" options={{renderInnerHtml: true}}/></p>
                                        <div className="centered-text">
                                            <Link className="btn btn-warning" to="/select-plan">
                                                <h2>
                                                    <Translate id="landing-page.subscribe-now" options={{renderInnerHtml: true}}/>
                                                </h2>
                                            </Link>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        </Container>
                    <LiveChat license={this.state.chatLiveChatLicense} />
                    </div>
                <Footer/>
            </div>
        )
    };
}

export default withLocalize(LandingPage);